import React, { useState } from 'react'
import { device } from '@styles/global/breakpoints'
import styled from 'styled-components'
import { renderSvg } from '@utils/genUtils'
import { svgs } from '@svg'
import { ButtonStyleReg } from '@styles/global/buttons'
import { motion } from 'framer-motion'

interface IProps {
  path: string
  isTop: boolean
}

function Navbar(props: IProps) {
  const { path, isTop } = props
  const [isOpen, setIsOpen] = useState(false)

  function navToggle() {
    setIsOpen(!isOpen)
  }

  return (
    <Nav data-testid='navbar'>
      <Logo data-testid='nav-logo'
        index={path === '/'}
        isTop={isTop}
        isOpen={isOpen}>
        <LogoContainer>
          {/*<Link*/}
          {/*  to='/'>*/}
          {/*  {renderSvg(svgs.ETLogo)}*/}
          {/*</Link>*/}
          <a href='https://every-tuesday.com/' rel='noreferrer' target='_blank'>
            {renderSvg(svgs.ETLogo)}
          </a>
        </LogoContainer>
      </Logo>
      <Hamburger
        isOpen={isOpen}
        index={path === '/'}
        isTop={isTop}
        data-testid='hamburger'
        onClick={navToggle}>
        {isOpen ? 'Close' : 'Menu'}
      </Hamburger>

      <NavLinks
        initial={'closed'}
        variants={navLinkVariants}
        animate={isOpen ? 'open' : 'closed'}
      >
        <NavRight
          index={path === '/'}
          isTop={isTop}
          isOpen={isOpen}>
          <Box variants={boxVariants} key={1}>
            <a href='https://every-tuesday.com/courses' rel='noreferrer' target='_blank'>Courses</a>
          </Box>
          <Box variants={boxVariants} key={2}>
            <a href='https://every-tuesday.com/products' rel='noreferrer' target='_blank'>Products</a>
          </Box>
          <Box variants={boxVariants} key={3}>
            <a href='https://every-tuesday.com/blog' rel='noreferrer' target='_blank'>Blog</a>
          </Box>
          <Box variants={boxVariants} key={4}>
            <a href='https://every-tuesday.com/resource-library' rel='noreferrer' target='_blank'>Resource Library</a>
          </Box>
          <Box variants={boxVariants} key={5}>
            <a href='https://courses.every-tuesday.com/sign_in/' rel='noreferrer' target='_blank'>Login</a>
          </Box>
        </NavRight>
      </NavLinks>
    </Nav>
  )
}

export default Navbar
const Nav = styled.nav`
	padding: 0;
	margin: 0 15px;
	height: 65px;
	width: 100%;
	display: grid;
	grid-template-columns: minmax(50px,1fr) minmax(50px,auto);
	align-items: flex-start;
	a{
	  color: ${props => props.theme.buttonPrimary.color};
	  &:hover{
	    color: ${props => props.theme.buttonPrimary.hoverColor};
	  }
	}
	@media ${device.laptop} {
		grid-template-columns: repeat(3,minmax(auto,1fr));
		position: relative;
		height: auto;
		padding: 10px 0;
	}
`

interface INavProps {
  isOpen: boolean,
  isTop: boolean,
  index: boolean
}

const Hamburger = styled(ButtonStyleReg) <INavProps>`
	background: ${props => props.isOpen ? props.theme.nav.color : 'transparent'};
	z-index: 1;
	border: 3px solid ${props => !props.isOpen && props.index && props.isTop
    ? '#fff'
    : props.theme.nav.color
  };
	display: flex;
	justify-content: center;
	text-align: center;
	align-items: center;
	padding: 8px 20px;
	text-transform: uppercase;
	font-size: .8rem;
	font-weight: 600;
	border-radius: 50px;;
	color: ${props => props.isOpen
    ? props.theme.nav.openColor
    : props.index && props.isTop ? '#fff' : props.theme.nav.color};
  align-self: center;
  transition: .3s;
	@media ${device.laptop} {
		display: none;
	}
`

const Logo = styled.div<INavProps>`
	display: grid;
	align-items: center;
	height: 100%;
	position: relative;
	z-index: 1;
	svg{
		width: 100%;
		path{
		  transition: .3s;
		  fill: ${props => (props.index && props.isTop && !props.isOpen)
    ? '#fff'
    : props.theme.logoColor};
		}
	}
	a{
		display: block;
	}
`
const LogoContainer = styled.div`
		max-width: 140px;
	@media ${device.laptop}{
		max-width: 234px;
	}
`

const navLinkVariants = {
  open: {
    x: 0,
    transition: {
      delayChildren: .4,
      staggerChildren: .07,
      duration: .3,
    },
  },
  closed: {
    x: `-100%`,

    transition: {
      delay: .5,
      staggerChildren: .02,
      staggerDirection: -1,
    }
  }
}
const boxVariants = {
  open: { opacity: 1, y: 0 },
  closed: { opacity: 0, y: 20 },
}
const Box = styled(motion.li)``
const NavLinks = styled(motion.div)`
	position: absolute;
	left: 0;
	height: 100vh;
	padding: 65px 0 0 0;
	width: 100%;
	background: ${props => props.theme.backgroundSecondary};
	
	@media ${device.laptop} {
	  padding: 0;
		position: relative;
		grid-column: 2 / -1;
		display: grid;
		grid-template-columns: repeat(2,minmax(auto,1fr));
		height: 100%;
		background: transparent;
		transform: translateX(0) translateZ(0)!important;
		transition: 0s;
	}
`
const NavRight = styled.ul<INavProps>`
  grid-column: 1 / -1;
  margin: 0;
  padding: 0;
  z-index: 0;
  position: relative;
	li{
		list-style: none;
		font-family: 'Fira Sans', sans-serif;
		font-weight: 500;
		text-transform: uppercase;
		border-bottom: 1px solid ${props => props.theme.lineColor};
	}
	a{
	  padding: 15px 30px;
	  width: 100%;
	  display: block;
	  color: ${props => props.index && props.isTop && !props.isOpen
    ? '#fff'
    : props.theme.nav.textColor}
	}
	
	@media ${device.laptop} {
	  z-index: 1;
		align-items: center;
		justify-content: flex-end;
		display: flex;
		flex-direction: row;
		padding: 0 0 0 40px;
		li{
		  opacity: 1!important;
		  transform: translateY(0) translateZ(0)!important;
		  border-bottom: none;
		  &:last-child{
		    a{
		      background: ${props => props.theme.logoColor};
		      border-radius: 25px;
		      color: #fff;
		      padding: 8px 25px;
		    }
		  }
		}
		a{
		  padding: 0 15px;
		}
	}
		
`
